import { Avatar, Button, Icons, useToggle } from '@commenda/kakashi';
import { BaseAssignee, Filing, FilingReviewStatus } from '../../molecules';
import { DeleteAssigneeModal } from './DeleteAssigneeModal';

interface AssigneeProps {
  assignee: BaseAssignee;
  filing: Filing;
  onRemoveAssignee: (assigneeId: string) => Promise<boolean>;
  onSuccess: () => void;
  hideDeleteAssignee?: boolean;
  loggedInUserEmail: string;
}

const AssigneeInfo = ({
  assignee,
  filing,
  onRemoveAssignee,
  onSuccess,
  hideDeleteAssignee,
  loggedInUserEmail,
}: AssigneeProps) => {
  const deleteAssigneeModalVisibility = useToggle();

  const isFilingCompletedOrFiled =
    filing.filingStatus === FilingReviewStatus.FILED;

  return (
    <div className="flex py-lg px-xl items-center justify-between">
      <DeleteAssigneeModal
        isOpen={deleteAssigneeModalVisibility.visible}
        onClose={deleteAssigneeModalVisibility.toggle}
        assignee={assignee}
        filing={filing}
        onRemoveAssignee={onRemoveAssignee}
        onSuccess={onSuccess}
        loggedInUserEmail={loggedInUserEmail}
      />
      <div className="flex items-center gap-2.5">
        <Avatar size="sm" name={assignee.name} />
        <div className="flex flex-col">
          <span className="txt-small-medium">{assignee.name}</span>
          <span className="txt-extra-small-regular text-text-tertiary">
            {assignee.email}
          </span>
        </div>
      </div>
      {!isFilingCompletedOrFiled && !hideDeleteAssignee && (
        <div className="flex items-center gap-2.5">
          <Button
            size="sm"
            variant="link"
            className="hover:text-button-tertiary-error-fg"
            onClick={deleteAssigneeModalVisibility.toggle}
          >
            <Icons.Trash01 className="size-4" />
          </Button>
        </div>
      )}
    </div>
  );
};

export { AssigneeInfo };
